import { getReviewFormData } from './get-review-form-data';
import { createReviewCreationData } from './create-review-creation-data';
import { createReview } from './create-review';

export type SubmitReviewParams = {
    rootElement: Pick<HTMLElement, 'querySelector' | 'dataset'>;
};
export const submitReview = async ({ rootElement }: SubmitReviewParams) => {
    const reviewFormData = await getReviewFormData({ rootElement });

    const reviewCreationData = createReviewCreationData({ rootElement, reviewFormData });

    const postResponse = await createReview(reviewCreationData);

    if (postResponse.status !== 201) {
        throw new Error(`Error submitting review: [${postResponse.status}] ${postResponse.statusText}`);
    }
};
